export default __webpack_public_path__ + "static/media/Gilroy-Light-11.cc7ab55d.otf";